//Source of the suggested data from Honeybee

// user's profile from substrate user profile api
export const UserProfile_InfoSource = 'Your Profile';

// file suggestion(s) from sharepoint
export const SharePoint_InfoSource = 'SharePoint';

// file suggestion(s) from  oneDrive
export const OneDrive_InfoSource = 'OneDrive';

// TBD: file suggestions(s) from exchange (classic attachments)
export const Exchange_InfoSource = 'Exchange';

export const Unknown_InfoSource = 'Unknown';
